import '@fancyapps/fancybox';
$(document).ready(function () {

    $.fancybox.defaults.loop = true;
    $.fancybox.defaults.clickOutside = "close";

    $.fancybox.defaults.clickContent = function(current, event) {
        return current.type === "image" ? "next" : false;
    }

    $.fancybox.defaults.btnTpl = {
        arrowLeft:
            '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left custom-arrow" title="{{PREV}}">' +
            '<div><svg class="icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 477.175 477.175" id="back">\n' +
            '        <path d="M145.188 238.575l215.5-215.5c5.3-5.3 5.3-13.8 0-19.1s-13.8-5.3-19.1 0l-225.1 225.1c-5.3 5.3-5.3 13.8 0 19.1l225.1 225c2.6 2.6 6.1 4 9.5 4s6.9-1.3 9.5-4c5.3-5.3 5.3-13.8 0-19.1l-215.4-215.5z"></path>\n' +
            '    </svg></svg>' +
            "</button>",

        arrowRight:
            '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right custom-arrow" title="{{NEXT}}">' +
            '<div><svg class="icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 477.175 477.175" id="next">\n' +
            '        <path d="M360.731 229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1 0s-5.3 13.8 0 19.1l215.5 215.5-215.5 215.5c-5.3 5.3-5.3 13.8 0 19.1 2.6 2.6 6.1 4 9.5 4 3.4 0 6.9-1.3 9.5-4l225.1-225.1c5.3-5.2 5.3-13.8.1-19z"></path>\n' +
            '    </svg></svg></div>' +
            "</button>",

        close:
            '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"/></svg>' +
            "</button>",
    }

    $.fancybox.defaults.buttons = [
        "fullScreen",
        "close"
    ]

    $('.review-text').readmore({
        ellipsis: '...',
        textOpen: 'Читать дальше',
        textClose: 'Закрыть',
        brief: 600,
        addition: 250
    })


    $('.more-image').on('click', function () {
        $.fancybox.open($('[data-fancybox="gallery"]'))
    })


    $(".popover-card").click(function () {
        $(".popover-card").popover('hide')
    })

    $(".popover-card").popover({
        html: true,
        trigger: 'click',
        placement: 'bottom',
        content: function () {
            var content = $(this).attr("data-popover-content");
            return $(content).html();
        }
    })

    $(window).bind('scroll', function () {
        $(".popover-card").popover('hide')
    })

})
